import React from 'react';
import { Typography, Button, Space } from 'antd';

const { Text } = Typography;

export const EmptyQueueState: React.FC<{
  message: string;
  actionLabel?: string;
  onAction?: () => void;
}> = ({ message, actionLabel, onAction }) => (
  <Space direction="vertical" size="small" style={{ padding: '8px 0' }}>
    <Text type="secondary">{message}</Text>
    {actionLabel && onAction && (
      <Button type="link" size="small" style={{ padding: 0 }} onClick={onAction}>
        {actionLabel}
      </Button>
    )}
  </Space>
);
